import React, { Component } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { withCookies } from 'react-cookie';
import { ChatContext } from '@/ChatProvider';
import TabPanelRequest from './TabPanelRequest'
import styles from '@styles/approvalCentral.module.css';

class Request extends Component {
    constructor(props) {
        super(props)
        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleTitle();
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:request'));
    }

    render() {
        return (
            <div className={styles.rootRequest}>
                <TabPanelRequest />
            </div>
        );
    }
}

Request.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(Request));